import { render, staticRenderFns } from "./Covid19.vue?vue&type=template&id=b49491b4&scoped=true&"
import script from "./Covid19.vue?vue&type=script&lang=ts&"
export * from "./Covid19.vue?vue&type=script&lang=ts&"
import style0 from "./Covid19.vue?vue&type=style&index=0&id=b49491b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49491b4",
  null
  
)

export default component.exports